import { mapSFToForm } from 'app/services/sfAuth/sfDataService'
import { CaseComment, caseCommentMapSF } from './CaseComment'
import { CreatedByRelationship } from './Common'
import { PortalLanguage } from './CommonTypes'

export const caseFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  ...CreatedByRelationship,
  ContactId: 'contact',
  AccountId: 'organization',
  SuppliedCompany: 'name',
  SuppliedName: 'userName',
  Status: 'status',
  OwnerId: 'owner',
  Origin: 'origin',
  Type: 'type',
  Subject: 'title',
  Comments: 'internalComments',
  Description: 'description',
  Description_Detailed__c: 'detailedDescription',
  Location_of_Contact_Us_submission__c: 'location',
  Region__c: 'region',
  Language__c: 'language',
  Prequalification__c: 'prequalificationId',
  Associated_Resource__c: 'resource',
  Associated_Opportunity__c: 'opportunityId',
  Related_Survey__c: 'surveyId',
  Skip_Assignment__c: 'skipAssigment',
  Error_Code__c: 'errorCode',
  CreatedDate: 'createdDate',
  CaseComments: {
    nonField: true,
    key: 'comments',
    in: (opp) => {
      return opp.CaseComments != null
        ? opp.CaseComments.records.map((obj) =>
          mapSFToForm(caseCommentMapSF, obj))
        : []
    }
  },
  Contact_name__c: 'userName'
}

export type FormErrorCode =
  | 'LD_01'
  | 'LD_02'
  | 'LD_03'
  | 'S_01'
  | '01'
  | 'G_01'
  | 'G_02'
  | 'Unknown'

export interface Case {
  id: string
  contact?: string
  organization?: string
  name: string
  userName: string
  status:
  | 'New'
  | 'In process'
  | 'On Hold'
  | 'Prospect contacted'
  | 'Closed'
  | 'Duplicate'
  | 'Irrelevant/ spam'
  owner: string
  origin: string
  title: string
  description: string
  region: string
  language: 'English' | 'French' | 'English/French' | 'Inuktitut'
  prequalificationId?: string
  opportunityId?: string
  detailedDescription?: string
  surveyId?: string
  skipAssigment?: boolean
  errorCode?: FormErrorCode
  location?: string
  resource?: string
  createdBy?: {
    id: string
    lastName: string
    firstName: string
    name: string
  }
  createdById?: string
  createdDate?: string
  suppliedName?: string
  comments?: CaseComment[]
}

export type CaseToCreateSF = Partial<Omit<Case, 'language' | 'id'>> & {
  language: PortalLanguage
}
